import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { EntraService } from './entra.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly entraService = inject(EntraService);
  private readonly msalService = inject(MsalService);

  get accountId() {
    return this.msalService.instance.getActiveAccount()?.localAccountId;
  }

  async getUserGroups(): Promise<string[]> {
    const account = this.msalService.instance.getActiveAccount() || this.msalService.instance.getAllAccounts()[0];
    if (!account) return [];
    const oid = account.idTokenClaims?.['oid'];
    if (!oid) return [];

    const cacheKey = `userGroups:${oid}`;
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      try { return JSON.parse(cached); } catch { sessionStorage.removeItem(cacheKey); }
    }

    const groups = await this.entraService.getEntraUserGroups();
    sessionStorage.setItem(cacheKey, JSON.stringify(groups));
    return groups;
  }


  getUserRoles(): string[] {
    const account = this.msalService.instance.getActiveAccount() || this.msalService.instance.getAllAccounts()[0];
    if (!account) {
      // No user is signed in, return an empty array
      return [];
    }

    return account.idTokenClaims && account.idTokenClaims['roles'] ? (account.idTokenClaims['roles'] as string[]) : [];
  }

  async userHasGroup(group: string): Promise<boolean> {
    const groups = await this.getUserGroups();
    return groups.includes(group);
  }

  async userHasRole(role: string): Promise<boolean> {
    const roles = this.getUserRoles();
    return roles.includes(role);
  }

  userHasAnyRole(roles: string[]): boolean {
    const userRoles = this.getUserRoles();
    return roles.some(role => userRoles.includes(role));
  }
}
